// extracted by mini-css-extract-plugin
export var activeItem = "Bottombar-module--activeItem--ThMf9";
export var container = "Bottombar-module--container--FS-Y9";
export var disabled = "Bottombar-module--disabled--3tijb";
export var nav = "Bottombar-module--nav--aLdJ0";
export var navItem = "Bottombar-module--navItem--Ba3hY";
export var navItemIcon = "Bottombar-module--navItemIcon--2vK+d";
export var navItemName = "Bottombar-module--navItemName--nUZ1y";